'use client';
import { useState } from 'react';

const OPTIONS = [
  { value: 'defini', label: 'Mon projet est défini, je veux ouvrir un dossier', emoji: '📋' },
  { value: 'renseignements', label: "J'ai besoin de renseignements", emoji: '💬' },
];

export default function StepQualification({ qualificationData, onNext, onBack }) {
  const [stade, setStade] = useState(qualificationData?.stade || '');
  const [precision, setPrecision] = useState(qualificationData?.precision || '');
  const [error, setError] = useState('');

  const MAX = 500;
  const sanitize = (val) => val.replace(/[<>"'`;\\]/g, '').slice(0, MAX);

  const handleSelect = (value) => {
    setStade(value);
    setError('');
    if (value === 'defini') {
      onNext({ stade: value, precision: '' });
    }
  };

  const handleNext = () => {
    if (!precision.trim()) {
      setError('Veuillez préciser votre question ou besoin avant de continuer.');
      return;
    }
    setError('');
    onNext({ stade, precision });
  };

  return (
    <div className="mx-auto max-w-5xl">
      <button
        type="button"
        onClick={onBack}
        className="mb-4 mt-3 flex items-center gap-2 text-sm text-gray-500 no-underline transition hover:text-gray-700 cursor-pointer"
      >
        ← Retour aux motifs
      </button>

      <div className="mb-6 text-center">
        <h2 className="!text-2xl font-bold text-gray-900 mb-2">
          Où en êtes-vous dans votre projet ?
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-3 mb-6">
        {OPTIONS.map(({ value, label, emoji }) => {
          const isSelected = stade === value;
          return (
            <button
              key={value}
              type="button"
              onClick={() => handleSelect(value)}
              className={[
                'group w-full rounded-2xl border text-left cursor-pointer transition-all duration-150',
                'focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2',
                'p-3',
                isSelected
                  ? 'border-indigo-600 bg-indigo-600 text-white shadow-md'
                  : 'border-gray-200 bg-white text-gray-900 shadow-sm hover:border-indigo-300 hover:bg-indigo-50 hover:shadow-sm',
              ].join(' ')}
            >
              <div className="flex items-center gap-3">
                <div
                  className={[
                    'shrink-0 rounded-xl p-2 transition-colors',
                    'flex h-10 w-10 items-center justify-center text-xl',
                    isSelected ? 'bg-white/15' : 'bg-indigo-100 group-hover:bg-indigo-200',
                  ].join(' ')}
                >
                  {emoji}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="block text-sm sm:text-[15px] font-semibold leading-5">
                      {label}
                    </span>
                    {isSelected && (
                      <span className="inline-flex items-center rounded-full bg-white/15 px-2 py-0.5 text-xs font-medium text-white">
                        Sélectionné
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </button>
          );
        })}
      </div>

      {stade === 'renseignements' && (
        <div className="mb-6 flex flex-col gap-3">
          <label className="text-sm font-semibold text-gray-900">
            Précisez votre question ou besoin
          </label>
          <textarea
            value={precision}
            onChange={(e) => setPrecision(sanitize(e.target.value))}
            placeholder="Décrivez brièvement votre situation…"
            rows={4}
            maxLength={MAX}
            className="w-full rounded-2xl border border-gray-200 bg-white p-3 text-sm text-gray-900 shadow-sm resize-none focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          />
          <p className="text-xs text-gray-400 text-right">{precision.length} / {MAX}</p>
          {error && (
            <p className="text-sm text-red-600 font-medium">{error}</p>
          )}
          <button
            type="button"
            onClick={handleNext}
            className="w-full rounded-2xl bg-indigo-600 px-6 py-3 text-sm font-semibold text-white shadow-md hover:bg-indigo-700 transition-colors cursor-pointer"
          >
            Continuer →
          </button>
        </div>
      )}
    </div>
  );
}
